export const isValidHex = (hex: string): boolean => /^#[0-9A-Fa-f]{6}$/.test(hex);
